/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Wizard_Toast_Users_Added_SingularInputs */



/**
* | output |
* | --- |
* | "{count} member added successfully" |
*
* @param {Spaces_Wizard_Toast_Users_Added_SingularInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_toast_users_added_singular = /** @type {((inputs: Spaces_Wizard_Toast_Users_Added_SingularInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Toast_Users_Added_SingularInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Mitglied erfolgreich hinzugefügt`)
	return /** @type {LocalizedString} */ (`${i?.count} member added successfully`)
});